import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';

interface Props {
  configPath: string;
  loadingComponent: React.ComponentType<any>;
}

const ConfigurationContext = React.createContext<ConfigurationProps | null>(null);

const ConfigurationProvider: React.FunctionComponent<Props> = (props) => {
  const [config, setConfig] = useState<ConfigurationProps>();
  const [error, setError] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  const { children, configPath, loadingComponent: LoadingComponent } = props;

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get<ConfigurationProps>(configPath);
        setConfig(res.data);
        setIsLoading(false);
      } catch (err) {
        setError(err as string);
        setIsLoading(false);
      }
    })();
  }, [configPath]);

  if (error) return <>{error}</>;
  if (isLoading || !config) return <LoadingComponent />;
  return <ConfigurationContext.Provider value={config}>{children}</ConfigurationContext.Provider>;
};

const useConfiguration = () => useContext(ConfigurationContext);

export default ConfigurationContext;

export { ConfigurationProvider, useConfiguration };

interface IdentityConfig {
  acr_values: string;
  authority: string;
  automaticSilentRenew: boolean;
  client_id: string;
  filterProtocolClaims: boolean;
  loadUserInfo: boolean;
  post_logout_redirect_uri: string;
  redirect_uri: string;
  response_type: string;
  scope: string;
  silentRequestTimeout: number;
  silent_redirect_uri: string;
}

export interface ConfigurationProps {
  iKey: string;
  publicGatewayApiUrl: string;
  bssGatewayApiUrl: string;
  environment: string;
  authorisationApiBaseUrl: string;
  invoicePortalUrl: string;
  invoiceApiUrl: string;
  identityConfig: IdentityConfig;
  version: string;
  apmBaseUrl: string;
}
